import Vue from 'vue'
import $ from 'jquery'
// eslint-disable-next-line
import slick from 'slick-carousel'
import ArrowLeft from '../../../assets/icons/slider-prev.svg'
import ArrowRight from '../../../assets/icons/slider-next.svg'

const SliderInvisalignDirective = Vue.directive('slider-invisalign-directive', {
  bind (el) {
    $(document).ready(function () {
      console.log('slider loaded')
      const slider = $(el)
      slider.slick({
        autoplay: true,
        prevArrow: `
          <button type="button" class="slick-prev">
            ${ArrowLeft}
          </button>
          `,
        nextArrow: `
          <button type="button" class="slick-next">
            ${ArrowRight}
          </button>
          `,
        draggable: false,
        fade: true
      })
    })
  }
})

export default SliderInvisalignDirective



// WEBPACK FOOTER //
// ./src/components/slider/invisalign/slider-invisalign.directive.js